import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IMainWebsite, IMainWebsiteCategory } from "../../../types/MainWebsite";
import { getMainWebsiteByID, pullMainWebsiteCategory } from "../actions";
import { Button, Drawer, Image, message, Table } from "antd";
import { PiPlus } from "react-icons/pi";
import {
  CategoriesColumns,
  MainWebsiteCategoryTableDataType,
} from "./../types";
import { CLOUD_URL } from "../../../lib/env";
import DashModal from "../../../Components/DashModal";
import AddNewCategory from "./AddNewCategory";
import EditCategoryImage from "./EditCategoryImage";
import EditCategoryTitle from "./EditCateogoryTitle";
import EditCategoryKeywords from "./EditCategoryKeyword";
import EditCategoryGeneral from "./EditCategory";
import EditCategoryDescription from "./EditCategoryDescription";
import ManageTop10Articles from "./ManageTop10Articles";
import ManageCategoryRichText from "./ManageCategoryRichText";
import SortCategory from "./SortCategory";
type Props = {
  page: number;
  pageSize: number;
  addNewCategory?: boolean;
  editImage?: boolean;
  editTitle?: boolean;
  editKeywords?: boolean;
  editCategory?: boolean;
  editDescription?: boolean;
  editTop10?: boolean;
  manageRichText?: boolean;
  addNewRichText?: boolean;
  editRichText?: boolean;
  sortItems?: boolean;
};

const Categories = (props: Props) => {
  const router = useNavigate();
  const { page, pageSize } = props;
  const { id } = useParams();
  const [mainWebsite, setMainWebsite] = useState<IMainWebsite | null>(null);
  const [categories, setCategoires] = useState<
    MainWebsiteCategoryTableDataType[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  const handleExpand = (
    expanded: boolean,
    record: MainWebsiteCategoryTableDataType
  ) => {
    setExpandedRowKeys(expanded ? [record.id] : []);
  };
  const fetchData = async () => {
    const main_website = await getMainWebsiteByID(id!);
    setMainWebsite(main_website);
    let categories_data: MainWebsiteCategoryTableDataType[] = [];
    if (main_website) {
      main_website.Categories.map((cat) => {
        categories_data.push({
          id: cat.id,
          title: cat.MainInfo.Title,
          image: cat.MainInfo.Image,
          keywords: cat.MainInfo.Keywords,
          top10articles: cat.Top10Articles,
        });
      });
    }
    setCategoires(categories_data);
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleDelete = async (category_id: string) => {
    try {
      await pullMainWebsiteCategory(id!, category_id);
      message.success("Category deleted");
      fetchData();
    } catch (error) {
      message.error("Failed to delete feature");
    }
  };
  return (
    <div className=" space-y-5">
      <div className="flex justify-between items-center">
        <Link
          to={`/main-websites/manage-categories/${id}/add?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="primary" icon={<PiPlus />}>
            Add New Category
          </Button>
        </Link>
      </div>{" "}
      <Table<MainWebsiteCategoryTableDataType>
        rowKey="id"
        columns={CategoriesColumns(id!, page, pageSize, handleDelete)}
        dataSource={categories}
        loading={loading}
        expandable={{
          expandedRowRender: (record) => (
            <Image width={200} src={CLOUD_URL + "/" + record.image} />
          ),
          rowExpandable: () => true,
          onExpand: handleExpand,
          expandedRowKeys,
        }}
      />{" "}
      {props.addNewCategory && (
        <DashModal
          title="Edit Category"
          width={800}
          cancleLink={`/main-websites/manage-categories/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <AddNewCategory fetchData={fetchData} />
        </DashModal>
      )}
      {props.editImage && (
        <DashModal
          title="Edit Category"
          width={600}
          cancleLink={`/main-websites/manage-categories/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <EditCategoryImage fetchData={fetchData} />
        </DashModal>
      )}
      {props.editTitle && (
        <DashModal
          title="Edit Category"
          width={800}
          cancleLink={`/main-websites/manage-categories/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <EditCategoryTitle fetchData={fetchData} />
        </DashModal>
      )}
      {props.editKeywords && (
        <DashModal
          title="Edit Category"
          width={1200}
          cancleLink={`/main-websites/manage-categories/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <EditCategoryKeywords fetchData={fetchData} />
        </DashModal>
      )}
      {props.editDescription && (
        <DashModal
          title="Edit Category"
          width={1200}
          cancleLink={`/main-websites/manage-categories/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <EditCategoryDescription fetchData={fetchData} />
        </DashModal>
      )}
      {props.editTop10 && (
        <DashModal
          title="Edit Category Top 10 Articles"
          width={1200}
          cancleLink={`/main-websites/manage-categories/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <ManageTop10Articles fetchData={fetchData} />
        </DashModal>
      )}{" "}
      {props.manageRichText && (
        <DashModal
          title="Manage Category Rich Texts"
          width={1200}
          cancleLink={`/main-websites/manage-categories/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <ManageCategoryRichText
            editRichText={props.editRichText}
            addNewRichText={props.addNewRichText}
            page={page}
            pageSize={pageSize}
          />
        </DashModal>
      )}{" "}
      {props.sortItems && (
        <DashModal
          title="Edit Sorted Items"
          width={900}
          cancleLink={`/main-websites/manage-categories/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <SortCategory fetchData={fetchData} />
        </DashModal>
      )}
      {props.editCategory && (
        <Drawer
          title="Edit Category"
          onClose={() =>
            router(
              `/main-websites/manage-categories/${id}?page=${
                page + 1
              }&pageSize=${pageSize}`
            )
          }
          open={true}
        >
          <EditCategoryGeneral page={page} pageSize={pageSize} />
        </Drawer>
      )}
    </div>
  );
};

export default Categories;
